import { useState } from "react";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import LinkIcon from '@mui/icons-material/Link';
import Modal from '@mui/material/Modal';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

const imgDW = [
    {
        alt: 'DW image',
        imgUrl: '/images/DWCertificate.png',
        credentialUrl: 'https://www.coderhouse.com/certificados/625eceff5b86060019e2c7e0'
    },
    {
        alt: 'JS image',
        imgUrl: '/images/JSCertificate.png',
        credentialUrl: 'https://www.coderhouse.com/certificados/62ce124fd672f700cd2a58dd'
    },
    {
        alt: 'React image',
        imgUrl: '/images/reactCertificate.png',
        credentialUrl: 'https://www.coderhouse.com/certificados/630e58e33482b80019af31ac'
    },
    {
        alt: 'Carrera image',
        imgUrl: '/images/carreraCertificate.png',
        credentialUrl: 'https://www.coderhouse.com/certificados/635441fc29b719001b8eb61b'
    }
]

const CertificateImgs = () => {
    const [openAsistance, setOpenAsistance] = useState(false);
    const handleOpenAsistance = () => setOpenAsistance(true);
    const handleCloseAsistance = () => setOpenAsistance(false);



    return (
        <div className="d-flex flex-column m-5">
            <div className="d-flex flex-column flex-md-row">
                {
                    imgDW.map(({ alt, imgUrl, credentialUrl }) => (
                        <Box key={alt} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <img className="w-75 m-2" src={imgUrl} alt={alt} />
                                <Modal
                                    open={openAsistance}
                                    onClose={handleCloseAsistance}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                    sx={{ display: 'flex', justifyContent: 'center' }}
                                >
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                        <img className="m-2 imgModal" src={imgUrl} alt={alt} />
                                        <Button onClick={handleCloseAsistance} sx={{ color: '#18ffff' }}>Close</Button>
                                    </Box>
                                </Modal>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                <a target='blanck' className="text-decoration-none w-25 d-flex justify-content-center align-items-center" href={credentialUrl}>
                                    <LinkIcon sx={{ fontSize: '2rem', color: '#18ffff' }} />
                                </a>
                                <Button onClick={handleOpenAsistance} sx={{ width: '25%' }}><AspectRatioIcon sx={{ color: '#18ffff' }} /></Button>
                            </Box>
                        </Box>
                    ))
                }
            </div>
        </div>
    );
}

export default CertificateImgs;